// extracted by mini-css-extract-plugin
export default {"container":"NewGroupSingleSelect-module__container--SOqCz"};